<app-ofwcas-list [ofwcas]="ofwcasSubject" [disableLinks]="true"></app-ofwcas-list>
